import Hero from "./Hero";
import Features from "./Features";
import Services from "./Services";
import PortfolioV from "./PortfolioV";
import FAQ from "./FAQ";
import Contact from "./Contact";
import WhatsAppButton from "../WhatsAppButton";
import ScrolltoTopButton from "../ScrollToTopButton";
import MeetJoan from "./MeetJoan";
import { Helmet } from "react-helmet";
import Seoimg from "../../Assets/ServiceImg/fpv.webp";
import { itemsAcademy } from "./PortfolioV";

function Academia({ cookiesAccepted }) {
   return (
      <div className="academ">
         <Helmet>
            <title key="title">
               Curso de Drones FPV y Configuración | Aprender FPV con Joan
               Company
            </title>
            <meta
               key="description"
               name="description"
               content="Aprende a volar drones FPV desde cero. Clases de vuelo cinemático en Mallorca, taller de Betaflight y asesoría de compra con un piloto profesional."
            />
            <meta
               key="keywords"
               name="keywords"
               content="aprender fpv, curso de drones fpv, taller betaflight, clases de vuelo fpv, configurar dron fpv, Joan Company drones"
            />
            <link
               rel="canonical"
               href="https://www.joancompany.es/aprender-fpv"
            />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content="Curso de Drones FPV y Configuración | Aprender FPV con Joan Company"
            />
            <meta
               property="og:description"
               content="Aprende a volar drones FPV desde cero. Clases de vuelo cinemático en Mallorca, taller de Betaflight y asesoría de compra con un piloto profesional."
            />
            <link rel="image_src" href={Seoimg} />
            <link rel="icon" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/aprender-fpv"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/aprender-fpv"
               hreflang="en"
            />
            <html lang="es" />
         </Helmet>
         <Hero cookiesAccepted={cookiesAccepted} />
         <Features />
         <MeetJoan />
         <Services />
         <PortfolioV
            cookiesAccepted={cookiesAccepted}
            HomePage={false}
            items={itemsAcademy}
         />
         <FAQ />
         <Contact />
         <WhatsAppButton />
         <ScrolltoTopButton />
      </div>
   );
}

export default Academia;
